import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div className='footer'>
            <p>&copy; SHOE GARDEN | Mehedi Hasan</p>
        </div>
    );
};

export default Footer;